module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-sm no-padder m-b"
  }, [_c('div', {
    staticClass: "bg-black"
  }, [_c('div', {
    staticClass: "wrapper-sm bg-dark font-bold text-uppercase"
  }, [_vm._v("\n      Entidades "), _c('u-button', {
    staticClass: "btn btn-info btn-xs pull-right m-b",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEntidadeForm.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" CADASTRAR NOVA ENTIDADE")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scroll-black scroll-lote"
  }, [_c('table', {
    staticClass: "table table-black",
    staticStyle: {
      "margin-top": "-36px"
    },
    attrs: {
      "id": "tableEntidades"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.entidades), function(entidade, index) {
    return (!_vm.entidadesLoading) ? _c('tr', [_c('td', [_c('div', [_vm._v("(" + _vm._s(entidade.tipo && entidade.tipo.nome || '-') + ")")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("upper")((entidade.nome || '(nome não informado)'))))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("upper")((entidade.endereco || '(endereco não informado)'))) + " " + _vm._s(entidade.numero || '(numero não informado)') + " " + _vm._s(_vm._f("upper")((entidade.complemento || '(complemento não informado)'))) + " " + _vm._s(_vm._f("upper")((entidade.bairro || '(bairro não informado)'))))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("upper")((entidade.estado || '(estado não informado)'))) + " - " + _vm._s(_vm._f("upper")((entidade.cidade || '(cidade não informada)'))) + " " + _vm._s(_vm._f("formataCep")((entidade.cep || '(cep não informado)'))))])]), _vm._v(" "), _c('td', [_c('u-button-group', {
      staticClass: "hidden-print",
      attrs: {
        "options": _vm.loteEntidadeOptions
      },
      on: {
        "change": function($event) {
          return _vm.atualizaStatusConsiderarEntidade(index)
        }
      },
      model: {
        value: (entidade.considerar),
        callback: function($$v) {
          _vm.$set(entidade, "considerar", $$v)
        },
        expression: "entidade.considerar"
      }
    }), _vm._v(" "), _c('u-button', {
      staticClass: "btn btn-sm btn-info pull-none-xs hidden-print m-l-sm",
      attrs: {
        "tabindex": "1"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openEntidadeForm(null, entidade.id)
        }
      }
    }, [_vm._v("Editar\n            ")]), _vm._v(" "), _c('u-button', {
      staticClass: "btn btn-sm btn-danger pull-none-xs hidden-print m-l-sm",
      attrs: {
        "tabindex": "1"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deletarEntidadeLote(null, entidade.id)
        }
      }
    }, [_vm._v("Excluir\n            ")])], 1)]) : _vm._e()
  }), _vm._v(" "), ((_vm.entidades && !_vm.entidades.length) && !_vm.entidadesLoading) ? _c('tr', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.entidadesLoading) ? _c('tr', [_vm._m(3)]) : _vm._e()], 2)])])]), _vm._v(" "), (_vm.showEntidadeForm) ? _c('popup-viewer', {
    attrs: {
      "title": "Edição de dados de Entidade"
    },
    on: {
      "close": _vm.closeEntidadeForm
    }
  }, [_c('NovaEntidadeLote', {
    attrs: {
      "entidadeId": _vm.entidadeSendoEditada
    },
    on: {
      "finishSubmit": _vm.closeEntidadeForm,
      "cancel": _vm.closeEntidadeForm
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-black pos-rlt",
    attrs: {
      "id": "tableEntidadesHead"
    }
  }, [_c('table', {
    staticClass: "table table-black bg-black m-b-none"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Entidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Opções")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Entidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Opções")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "no-borders",
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Nenhuma entidade encontrada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "no-borders text-center",
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner m-t fa-2x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55857070","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/gerenciamento-lote-entidade/GerenciamentoEntidadeLote.vue
// module id = 1866
// module chunks = 18